"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = configureStore;

var _redux = require("redux");

var _enviro = _interopRequireDefault(require("enviro"));

var _reduxThunk = _interopRequireDefault(require("redux-thunk"));

var _usageTrackerMiddleware = _interopRequireDefault(require("FileManagerCore/utils/redux/usageTrackerMiddleware"));

var _UsageTracking = require("FileManagerLib/utils/UsageTracking");

var _floatingAlertMiddleware = _interopRequireDefault(require("FileManagerLib/utils/redux/floatingAlertMiddleware"));

var _reducers = _interopRequireDefault(require("FileManagerLib/reducers"));

var _utils = require("FileManagerLib/utils/utils");

var _selectionMiddleware = _interopRequireDefault(require("FileManagerLib/utils/redux/selectionMiddleware"));

var composeEnhancers = _redux.compose;

if (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ && _enviro.default.debug('FILE_MANAGER_LIB')) {
  // enviro.debug('FILE_MANAGER_LIB') === true when localStorage.FILE_MANAGER_LIB_DEBUG === true
  composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
    name: 'FileManagerLib'
  });
}

function configureStore(initialState, _ref) {
  var httpClient = _ref.httpClient,
      usageTracker = _ref.usageTracker;
  var usageTrackerWithNamespaceUpdated = (0, _utils.getUsageTrackerWithNamespaceMaybeUpdated)(usageTracker);
  var createStoreWithMiddleware = composeEnhancers((0, _redux.applyMiddleware)(_reduxThunk.default.withExtraArgument(httpClient)), (0, _redux.applyMiddleware)((0, _usageTrackerMiddleware.default)(usageTrackerWithNamespaceUpdated, (0, _UsageTracking.makeEventPayloadHandler)(usageTrackerWithNamespaceUpdated), {
    persistWhereOptions: false
  }), (0, _floatingAlertMiddleware.default)()), (0, _redux.applyMiddleware)(_selectionMiddleware.default))(_redux.createStore);
  return createStoreWithMiddleware(_reducers.default, initialState);
}

module.exports = exports.default;